import type { FaireProductEntity } from "../../entity_types/product";

export const p_9cyuacbxek: FaireProductEntity = {
  token: "p_9cyuacbxek",
  type: "product",
  name: "Focus Essential Oil Roller Ball Peppermint & Eucalyptus",
  brandToken: "b_7jqwqwjp5c",
  brandName: "Aromalee Shop",
  imageUrl:
    "https://cdn.faire.com/fastly/8a8a971f78f33e48ce13c84f27c67e4cc4d59cecb0b27d4630d9fcb405c5d383.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fbdb439caa65c1537476f6418a4a172d9e2965c1d8acad6e25282a650d758002.png",
    "https://cdn.faire.com/fastly/38d85ecb11d13088365cefb1813797fba4897ed4930804d404c5e0434e600928.jpeg",
  ],
  priceDollars: 12.47,
  description:
    "100% Natural Botanical Oil Blend:\n▫️Infused With Aquamarine Crystals & Orange Eucalyptus \n▫️Scented With Peppermint & Eucalyptus Essential Oils \n▫️ Hand Poured With Organic Grapeseed Oil \n\nBenefits: \n▫️Boosts Clarity and Focus \n▫️Calms Mental Stress \n▫️Aids With Headaches and Colds \n\nHow to apply:\n▫️Roll on with intention along hairline, head, neck, shoulders, and wrists \n\nDisclaimer: \n▫️Not FDA approved \n▫️For topical use only",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:58.090Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
